import apiClient from "./apiClient";

export const createBreach = async (formData) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.post("/data_breach", formData, {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDataBreaches = async () => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get("/data_breach", {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getBreachData = async (breachId) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get(`/data_breach/${breachId}`, {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const assignBreachUser = async (breachId, payload) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.put(
      `/update_assignee/${breachId}`,
      payload,
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBreachStatusChange = async (breachId, formData) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.put(
      `/update_status/${breachId}`,
      formData,
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateBreachPresignedUrl = async (filename) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.post(
      "/get_upload_url",
      {
        file_name: filename,
      },
      {
        headers: {
          website_id: websiteId,
        },
      }
    );

    if (response.data?.status_code === 200 && response.data?.success) {
      return {
        presigned_url: response.data.data.url, // Extract URL from response
        file_name: response.data.data.file_name, // Extract file name from response
      };
    } else {
      throw new Error(response.data?.message || "Failed to generate URL");
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to generate URL");
  }
};

export const getBreachPresignedUrl = async (fileName) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get(`/get_presigned_url/${fileName}`, {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateEmail = async (breachId) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get(
      `/generate_email_template/${breachId}`,
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDataBreach = async (breachId, formData) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.put(
      `/data_breach/${breachId}`,
      formData, // ✅ Correctly sending form data
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
